import { CUSTOM_STAGE_KINDS, STAGE_KIND_LABELS } from '@hearth/shared';
import { pluralize } from '../../../lib/format';
import { LookupEditor } from './LookupEditor';

const leads = (item: { leadCount?: number }) => pluralize(item.leadCount ?? 0, 'lead');

export function PipelineSection() {
  return (
    <>
      <LookupEditor
        config={{
          title: 'Pipeline stages',
          description: 'Where each pizzeria is in your sales process. Keys never change; built-in stages can be renamed or hidden.',
          endpoint: '/api/settings/stages',
          nameField: 'label',
          color: true,
          activeToggle: true,
          kindOptions: CUSTOM_STAGE_KINDS.map((kind) => ({ value: kind, label: STAGE_KIND_LABELS[kind] })),
          reorder: true,
          reassignBodyKey: 'reassignToStageId',
          usage: leads,
        }}
      />
      <LookupEditor
        config={{
          title: 'Relationship statuses',
          description: 'How well you know each pizzeria — separate from the pipeline stage. Statuses that block outreach stop every email.',
          endpoint: '/api/settings/relationships',
          nameField: 'label',
          color: true,
          activeToggle: true,
          blocksOutreach: true,
          reorder: true,
          reassignBodyKey: 'reassignToStatusId',
          usage: leads,
        }}
      />
    </>
  );
}
